import {Col, Row} from "react-bootstrap";
import {get_website_url} from "@bigyellow/routes";
import React from "react";

const NotAllowedToCheckinMessage=()=>{

   return  <React.Fragment>
        <Row>
            <Col className={`text-center`}>
                You're up to date and do not have any rooms you need to Check-in Online to.
                If this is not the case, please contact your local store.
                <div className={`my-4`}>
                    <a className={`btn btn-primary`} href={get_website_url().replace('boxshop/','')}>
                        Return to homepage
                    </a>
                </div>
            </Col>
        </Row>
    </React.Fragment>
}

export default NotAllowedToCheckinMessage;